import {Tooltip} from 'platform/components';
import {Box, HStack, Icon, Show, Space, Text} from 'platform/foundation';
import {css} from 'styled-components';

import {isNilOrEmpty, isNotNilOrEmpty} from 'ramda-adjunct';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

export type DataColumnItem = {
  label: string;
  value: number | string | Nullish;
  labelTooltip?: string | Nullish;
  colorCode?: string;
};

export type DataColumnProps = {
  data: DataColumnItem[];
};

export const DataColumn = (props: DataColumnProps) => (
  <>
    {props.data.map(({label, value, colorCode, labelTooltip}) => {
      if (isNilOrEmpty(value)) {
        return null;
      }
      return (
        <Box key={label + value} paddingVertical={2}>
          <HStack key={label + value}>
            <Box flex={1}>
              <HStack align="center" spacing={1}>
                <Text size="small" color="secondary">
                  {label}
                </Text>
                <Show when={isNotNilOrEmpty(labelTooltip)}>
                  <Tooltip label={labelTooltip}>
                    <Icon value="action/info" size={4} color="text.tertiary" />
                  </Tooltip>
                </Show>
              </HStack>
            </Box>
            <Box flex={1}>
              <HStack height="100%" align="center">
                <Show when={isNotNilOrEmpty(colorCode)}>
                  <>
                    <div
                      css={css`
                        border-radius: ${({theme}) => theme.radii.medium};
                        border: 1px solid ${({theme}) => theme.colors.palettes.neutral[40][100]};
                        background-color: ${colorCode};
                        width: ${({theme}) => theme.getSize(4)};
                        height: ${({theme}) => theme.getSize(4)};
                      `}
                    />
                    <Space horizontal={2} />
                  </>
                </Show>
                <Text alternative size="small" overflowWrap="anywhere">
                  {String(value ?? EMPTY_PLACEHOLDER)}
                </Text>
              </HStack>
            </Box>
          </HStack>
        </Box>
      );
    })}
  </>
);
